import React from 'react';
import EnumInput from './EnumInput';
import { ObjectInput } from './ObjectInput';
import ArrayInput from './ArrayInput';
import { ApiAttribute } from '@context/openapi/types';
import FilterInput from './FilterInput';
import Input from './Input';
import JSONInput from './JSONInput';

interface RenderFieldProps {
  field: ApiAttribute;
  index?: number | null;
  onChange: (field: ApiAttribute, value: string) => void;
  onFilterChange?: (field: ApiAttribute, value: string) => void;
  onUpdateItem?: (field: ApiAttribute) => void;
  fieldNameOverride?: string;
  isEmptyAttributesVisible: boolean;
}

export const RenderFields: React.FC<RenderFieldProps> = ({
  field,
  index,
  onChange,
  onFilterChange,
  onUpdateItem,
  fieldNameOverride,
  isEmptyAttributesVisible,
}) => {
  switch (field.type) {
    case 'STRING':
    case 'NUMBER':
    case 'DATE':
      return (
        <Input
          field={field}
          onChange={onChange}
          fieldNameOverride={fieldNameOverride}
        />
      );
    case 'ENUM':
    case 'BOOLEAN':
      return <EnumInput field={field} onChange={onChange} />;
    case 'OBJECT':
      if (field.child && field.child.length === 0) {
        return <JSONInput field={field} onChange={onChange} />;
      }
      return (
        <ObjectInput
          field={field}
          onChange={onChange}
          onFilterChange={onFilterChange}
          key={index}
          isEmptyAttributesVisible={isEmptyAttributesVisible}
        />
      );
    case 'ARRAY':
      return (
        <ArrayInput
          field={field}
          updateItem={onUpdateItem}
          key={index}
          onChange={onChange}
          onFilterChange={onFilterChange}
          childFieldNameOverride="item"
          isEmptyAttributesVisible={isEmptyAttributesVisible}
        />
      );
    case 'FILTER':
      return (
        <FilterInput
          field={field}
          key={index}
          onChange={onChange}
          onFilterChange={onFilterChange}
        />
      );
    case 'JSON':
      return <JSONInput field={field} onChange={onChange} />;
    default:
      return null;
  }
};
